console.log('process.env', process.env)
const serverList = [
    {
        BASEURL: 'http://192.168.68.106:8407',
    },
    {
        BASEURL: 'https://hly.hlygames.com/gameapi',
    },
];
let serverArr;

serverArr = serverList[1]
export default serverArr
